import { useLimitTransaction } from "@/hooks/credit/use-limit-transaction";
import LimitExpiredCreditModal, {
  LimitExpiredCreditModalProps,
} from "@/components/modal/license-limited-modals/credit/base/limit-expired-credit-modal";
import { $creditPriceList } from "@/data/credit-transaction.constants";

const ConvertLimitExpiredCreditModal = ({
  handleUseCreditsClick,
}: LimitExpiredCreditModalProps) => {
  const { buyConvertLimit } = useLimitTransaction();

  return (
    <LimitExpiredCreditModal
      action={"convert"}
      priceInCredits={$creditPriceList.convertLimitPrice}
      onUseCreditsClick={() =>
        handleUseCreditsClick(
          buyConvertLimit,
          $creditPriceList.convertLimitPrice,
        )
      }
    />
  );
};

export default ConvertLimitExpiredCreditModal;
